<template>
  <div 
		:class="[ 
      'tracker ui',
      { active: elapsed } 
    ]"
    :style="{ 
      '--width': width,
    }"
    tabindex="0"
    aria-label="video scrubber. Use left and right arrow keys to scrub."
    @mousemove="getPosition($event)"
    @mouseout="hoverPosition = null"
    @click.stop="$emit('desiresTime', desiredTime)"
    @keydown.right.stop="hoverPosition = ( hoverPosition || ( currentTime / duration ) ) + 0.05"
    @keydown.left.stop="hoverPosition = ( hoverPosition || ( currentTime / duration ) ) - 0.05"
    @keydown.enter.stop="$emit('desiresTime', desiredTime)"
	>
    <span class="time">
      {{ timestamp }}
    </span>
  </div>
</template>

<script>
export default {
	name: 'Tracker',
	props: [ 
    'duration',
    'currentTime'
  ],
  data() {
    return {
      hoverPosition: 0
    }
  },
  computed: {
    elapsed() { return this.currentTime / this.duration },
    desiredTime() { return this.hoverPosition * this.duration },
    width() { return `${ 100 * ( this.hoverPosition || this.elapsed ) }%` },
    timestamp() { return `
      ${this.humanReadable(
          this.desiredTime || this.currentTime
      )} 
        / 
      ${this.humanReadable(
          this.duration
      )}
    `}
  },
  methods: {
    getPosition(e) {
      this.hoverPosition = e.layerX / e.target.offsetWidth
    },
    humanReadable: time => {
      const 
        tt = Math.floor(time),
        hh = Math.floor( tt / 3600 ).toString().padStart(2, '0'),
        mm = Math.floor( tt / 60 - hh * 60 ).toString().padStart(2, '0'),
        ss = Math.floor( tt - ( hh * 3600 + mm * 60 ) ).toString().padStart(2, '0')
      return `${hh}:${mm}:${ss}`
    }, 

  },
}
</script>

<style scoped>

.tracker {
  --speed: 0.1s;
  position: relative;
  box-sizing: border-box;
  height: 60%;
  width: 100%;
  border-radius: 100px;
  padding: 0px 20px;
  color: var(--light1);
  border-color: var(--light1);
  transition: all var(--speed) ease;
  cursor: pointer;
  margin: 2em;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: col-resize;
}

.tracker.ui,
.tracker.ui::before,
.tracker.ui::after {
  box-sizing: border-box;
  opacity: 0.9;
  border-radius: 5em;
  animation: unset;
  transform: scale(1);
  left: 0;
  width: 100%;
}
.tracker.ui::before {
  top: 0;
}

.tracker.ui::after {
  width: var(--width);
  top: 5%;
  transition: 
    filter var(--slow) ease,
    transform var(--slow) ease,
    opacity var(--slow) ease,
    background var(--slow) ease,
    box-shadow var(--slow) ease,
    width var(--slow) ease
  ;
}
.tracker.ui:hover::after {
  transition: 
    filter var(--slow) ease,
    transform var(--slow) ease,
    opacity var(--slow) ease,
    background var(--slow) ease,
    box-shadow var(--slow) ease,
    width var(--veryfast) ease
  ;
}

.tracker .time {
  pointer-events: none;
  transition: margin var(--veryfast) ease;
  color: var(--back);
  /* margin-right: calc(100% - var(--width) + 10px); */
  word-break: keep-all;
  min-width: 200px;
  /* width: 0; */
  overflow: visible;
}

.tracker.ui:hover .time {
  margin-right: calc(100% -  var(--width));
}

@keyframes live {
  0% { box-shadow: 0 0 20px 0px var(--highlight); }
  100% { box-shadow: 0 0 10px 0px var(--highlight); }
}

.isMobile .tracker {
  height: 80%;
  margin: 0.5em;
  margin-right: 0;
}

</style>
